import {createAsyncThunk} from '@reduxjs/toolkit';
import type {
  CheckEmailVerificationBackendResponse,
  CheckEmailVerificationResponse,
  CreateSenderProfileResponse,
  DeleteSenderProfileResponse,
  InitEmailMarketingCampaignSettingsResponse,
  IsEmailVerifiedBackendResponse,
  IsEmailVerifiedResponse,
  SenderProfile,
  SenderProfileIdPayload,
  SenderProfilePayload,
  UpdateDefaultSenderProfileResponse,
  UpdateSenderProfilePayload,
} from './email-marketing-campaign-settings.types';

export const initEmailMarketingCampaignSettings = createAsyncThunk('initEmailMarketingCampaignSettings', async (): Promise<InitEmailMarketingCampaignSettingsResponse> => {
  return (await window.PMW.readLocal('emailmarketing/initEmailMarketingCampaignSettings')) as InitEmailMarketingCampaignSettingsResponse;
});

export const deleteSenderProfile = createAsyncThunk('deleteSenderProfile', async (data: SenderProfileIdPayload): Promise<DeleteSenderProfileResponse> => {
  return (await window.PMW.writeLocal('emailmarketing/deleteSenderProfile', data)) as DeleteSenderProfileResponse;
});

export const updateSenderProfile = createAsyncThunk('updateSenderProfile', async (data: UpdateSenderProfilePayload): Promise<SenderProfile> => {
  return (await window.PMW.writeLocal('emailmarketing/updateSenderProfile', data)) as SenderProfile;
});

export const createSenderProfile = createAsyncThunk('createSenderProfile', async (data: SenderProfilePayload): Promise<CreateSenderProfileResponse> => {
  return (await window.PMW.writeLocal('emailmarketing/createSenderProfile', data)) as CreateSenderProfileResponse;
});

export const updateDefaultSenderProfile = createAsyncThunk('updateDefaultSenderProfile', async (data: SenderProfileIdPayload): Promise<UpdateDefaultSenderProfileResponse> => {
  return (await window.PMW.writeLocal('emailmarketing/updateDefaultSenderProfile', data)) as UpdateDefaultSenderProfileResponse;
});

export const resendSenderProfileVerificationEmail = createAsyncThunk('resendSenderProfileVerificationEmail', async (data: SenderProfileIdPayload): Promise<unknown> => {
  return window.PMW.writeLocal('emailmarketing/resendVerificationEmail', data);
});

export const isEmailVerifiedForSenderProfile = createAsyncThunk('isEmailVerifiedForSenderProfile', async (data: SenderProfileIdPayload): Promise<IsEmailVerifiedResponse> => {
  const response = (await window.PMW.readLocal('emailmarketing/isEmailVerifiedForSenderProfile', data)) as IsEmailVerifiedBackendResponse;
  return {
    isVerified: response.isVerified,
    idSenderProfile: Number(response.idSenderProfile),
  };
});

export const checkEmailVerificationForSenderProfile = createAsyncThunk(
  'checkEmailVerificationForSenderProfile',
  async (data: SenderProfileIdPayload): Promise<CheckEmailVerificationResponse> => {
    const response = (await window.PMW.readLocal('emailmarketing/checkEmailVerificationForSenderProfile', data)) as CheckEmailVerificationBackendResponse;
    return {
      isAvailable: response.isAvailable,
      data: {idSenderProfile: Number(response.data.idSenderProfile)},
    };
  }
);
